import { CenteringDiv, FlexRowDiv, H3, P } from 'components/generic/HomePageComponents'

const Testimonials = ({ testimonialAuthor, testimonialContent }) => (
  <FlexRowDiv pt='50px'>
    <CenteringDiv justifyContent='flex-start'>
      <H3 fontWeight='bold' m={{ _: '22px 0 0', tablet: '10px 0' }} fontSize='22px'>
        WHAT OTHERS ARE SAYING
      </H3>
      <P
        fontSize='22px'
        textAlign='center'
        mt={{ _: '10px', tablet: 0 }}
        mb='10px'
        width={{ _: '100%', tablet: '80%' }}
        maxWidth={{ _: '300px', tablet: 'none' }}
      >
        {testimonialContent}
      </P>
      <P fontWeight='normal' fontSize='18px' lineHeight='1.13'>
        {testimonialAuthor}
      </P>
    </CenteringDiv>
  </FlexRowDiv>
)

export default Testimonials
